// extracted by mini-css-extract-plugin
export default {"searchPanel":"KyabIW9REDp6kp_fKlIt","searchInput":"vxKXy4ckIuxmHpBdO5mE","searchIcon":"avXVvwbV_F1mSjk_vgZD"};